const enterprise_subscription = {
    page_title: 'Подписка',
    title: 'Управляйте своей подпиской',
    subtitle: 'Это управление вашей многопользовательской подпиской и историей платежей',
    tab: {
        subscription: 'Подписка',
        billing_history: 'История платежей',
    },
    subscription: {
        title: 'Подписка',
        description: 'Легко отслеживайте использование, смотрите свой следующий счет и просматривайте свой оригинальный контракт.',
        enterprise_plan_title: 'Корпоративный план',
        enterprise_plan_description: 'Это ваша подписка на корпоративный план, и эта квота распределяется между арендаторами. Обновление использования может быть немного задержано. ',
        add_on_title: 'Дополнения с поминутной оплатой',
        add_on_description: 'Это дополнительные дополнения с оплатой по мере использования на основе вашего контракта или стандартных ставок Logto. Вы будете платить в соответствии с вашим фактическим использованием.',
        included: 'Включено',
        over_quota: 'Перерасход',
        basic_plan_column_title: {
            product: 'Продукт',
            usage: 'Использование',
            quota: 'Квота',
        },
        add_on_column_title: {
            product: 'Продукт',
            unit_price: 'Цена за единицу',
            quantity: 'Количество',
            total_price: 'Итоговая сумма',
        },
        add_on_sku_price: '${{price}}/месяц',
        private_region_title: 'Частный облачный экземпляр ({{regionName}})',
        shared_cross_tenants: 'Между арендаторами',
    },
    user_subscriptions: {
        description: 'Просматривайте личные подписки и договорные квоты Enterprise независимо от выбранного арендатора.',
        personal_title: 'Личные подписки',
        personal_description: 'Активные подписки, оплачиваемые вашим аккаунтом. Прошлые подписки остаются в истории платежей.',
        price: 'Цена',
        next_charge: 'Следующее списание',
        ends_on: 'Завершается {{date}}',
        overdue_note: 'Платёж просрочен. Если он останется неоплаченным, подписка может быть приостановлена, а её платные функции — удалены.',
        other_product: 'Другая подписка',
        enterprise_invoices_description: 'Счета по вашему договору Enterprise. Выберите счет, чтобы просмотреть его и скачать счет или квитанцию.',
        personal_invoices_description: 'Счета по подпискам, оплачиваемым с вашего аккаунта, включая прошлые подписки. Выберите счет, чтобы просмотреть его и скачать счет или квитанцию.',
        credit_note: 'Кредиты за удаления или пропорциональные перерасчеты уменьшают последующие счета и не обязательно сразу возвращаются на ваш способ оплаты.',
        invoice_link_unavailable: 'Страница этого счета недоступна. Свяжитесь с нами, если вам нужна копия.',
        status: {
            active: 'Активна',
            trialing: 'Пробная',
            past_due: 'Просрочена',
            unpaid: 'Не оплачена',
            canceled: 'Отменена',
            incomplete: 'Не завершена',
            incomplete_expired: 'Истекла',
            paused: 'Приостановлена',
        },
    },
};
export default Object.freeze(enterprise_subscription);
